import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import AddMsg from "../AddMsg/AddMsg";

export default function TopCard({ reload, userType }) {
  const [isDialogVisible, setDialogVisible] = useState(false);

  const handleOpenDialog = () => setDialogVisible(true);
  const handleCloseDialog = () => setDialogVisible(false);

  return (
    <div
      style={{
        height: 45,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      {userType === 1 && (
        <button
          onClick={handleOpenDialog}
          className="NavLinkBtn large unselectlink marginright"
          aria-label="Add new trading rule"
        >
          ADD MESSAGE
        </button>
      )}

      <Dialog
        visible={isDialogVisible}
        onHide={handleCloseDialog}
        position="center"
        closeOnEscape
        closeIcon
        transitionOptions={false}
        focusOnShow={false}
        draggable={false}
        resizable={false}
        header="Add New Message"
      >
        <AddMsg close={handleCloseDialog} reload={reload} />
      </Dialog>
    </div>
  );
}
